import { Dimensions, Platform } from 'react-native';
import * as SecullumReactNativeUI from 'secullum-react-native-ui';
import { isTablet } from 'secullum-react-native-ui';

export const isHighResolution = () =>
  Dimensions.get('window').height >= 600 &&
  Dimensions.get('window').width >= 600;

export const isDesktop = () => Dimensions.get('window').width >= 1024;

export const Amarelo100 = '#FFC600';

export const Cinza100 = '#53565A';
export const Cinza90 = '#64676B';
export const Cinza80 = '#76787C';
export const Cinza70 = '#87898D';
export const Cinza60 = '#989A9E';
export const Cinza50 = '#AAACB0';
export const Cinza40 = '#BBBDC1';
export const Cinza30 = '#CDCED3';
export const Cinza20 = '#DEE0E4';
export const Cinza10 = '#EFF0F2';
export const Cinza5 = '#F7F8F9';
export const Cinza2 = '#FBFBFC';

export const getTheme = () => {
  SecullumReactNativeUI.setTheme({
    textColor1: Cinza100,
    textColor2: Cinza100,
    textColor3: Cinza100,
    dropDownTextColor: Cinza100,
    menuSelectedTextColor: Amarelo100,
    radioSelectedBackgroundColor: Cinza100,
    backgroundColor1: '#ffffff',
    backgroundColor2: Cinza5,
    backgroundColor3: Cinza100,
    datePickerColor: Cinza100,
    borderColor1: Cinza30,
    statusBarColor: Cinza100,
    successColor: '#78D648',
    warningColor: Amarelo100,
    errorColor: '#F14D52',
    disabledColor: Cinza20
  });

  return SecullumReactNativeUI.getTheme();
};

export const select = ({
  web,
  tablet,
  defaultValue,
  highResolution
}: SelectOptions) => {
  const webPlatform = Platform.OS === 'web';

  if (highResolution && webPlatform && isHighResolution()) {
    return highResolution;
  }

  if (web && webPlatform) {
    return web;
  }

  if (tablet && isTablet()) {
    return tablet;
  }

  return defaultValue;
};

interface SelectOptions {
  web?: any;
  tablet?: any;
  defaultValue?: any;
  highResolution?: any;
}
